/**
 * @generated SignedSource<<4818f09415cf2a52371f614fe694668a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type CurriculumLessonsFilterInput = {
  hasExitSlip?: boolean | null | undefined;
  isActive: ActiveRecords;
  lessonNames?: ReadonlyArray<string> | null | undefined;
  lessonNumbers?: ReadonlyArray<string> | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  targetGroupId?: string | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
};
export type ExitSlipCurriculumLessonsQuery$variables = {
  filter?: CurriculumLessonsFilterInput | null | undefined;
};
export type ExitSlipCurriculumLessonsQuery$data = {
  readonly curriculumLessons: ReadonlyArray<{
    readonly classExitSlips: ReadonlyArray<{
      readonly canceledOn: any | null | undefined;
      readonly class: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly dueOn: any;
      readonly id: string;
    } | null | undefined> | null | undefined;
    readonly curriculumLessonTargetSkills: ReadonlyArray<{
      readonly targetSkill: {
        readonly skill: {
          readonly code: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly hasExitSlip: boolean;
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string | null | undefined;
    readonly number: string | null | undefined;
    readonly target: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
  }>;
};
export type ExitSlipCurriculumLessonsQuery = {
  response: ExitSlipCurriculumLessonsQuery$data;
  variables: ExitSlipCurriculumLessonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExitSlip",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetNode",
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ClassExitSlipNode",
  "kind": "LinkedField",
  "name": "classExitSlips",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canceledOn",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ClassNode",
      "kind": "LinkedField",
      "name": "class",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipCurriculumLessonsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CurriculumLessonNode",
        "kind": "LinkedField",
        "name": "curriculumLessons",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurriculumLessonTargetSkillNode",
            "kind": "LinkedField",
            "name": "curriculumLessonTargetSkills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillNode",
                "kind": "LinkedField",
                "name": "targetSkill",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillNode",
                    "kind": "LinkedField",
                    "name": "skill",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipCurriculumLessonsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CurriculumLessonNode",
        "kind": "LinkedField",
        "name": "curriculumLessons",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurriculumLessonTargetSkillNode",
            "kind": "LinkedField",
            "name": "curriculumLessonTargetSkills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillNode",
                "kind": "LinkedField",
                "name": "targetSkill",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillNode",
                    "kind": "LinkedField",
                    "name": "skill",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "704e8ff323c83474eec6a49c0e5964a6",
    "id": null,
    "metadata": {},
    "name": "ExitSlipCurriculumLessonsQuery",
    "operationKind": "query",
    "text": "query ExitSlipCurriculumLessonsQuery(\n  $filter: CurriculumLessonsFilterInput\n) {\n  curriculumLessons(filter: $filter) {\n    id\n    hasExitSlip\n    isActive\n    name\n    number\n    target {\n      id\n      name\n    }\n    curriculumLessonTargetSkills {\n      targetSkill {\n        skill {\n          code\n          id\n        }\n        id\n      }\n      id\n    }\n    classExitSlips {\n      dueOn\n      canceledOn\n      id\n      class {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7179fc9d6b3f14634cd3dd8bdd23067";

export default node;
